import React from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'

export const AnimationLink = props => {
  const { id, ...restProps } = props

  if (props.to === '#') {
    const {
      to: _to,
      children,
      className,
      style,
      title,
      onClick,
      onMouseEnter,
      onMouseLeave,
      onFocus,
      onBlur,
      onKeyDown,
      paintDrip: _paintDrip,
      hex: _hex,
      ...remainder
    } = props

    const extraDom = {}
    Object.keys(remainder).forEach(k => {
      if (
        k.startsWith('aria-') ||
        k.startsWith('data-') ||
        k === 'role' ||
        k === 'tabIndex'
      ) {
        extraDom[k] = remainder[k]
      }
    })

    const handleClick = e => {
      e.preventDefault()
      if (onClick) {
        onClick(e)
      }
    }

    return (
      <a
        href="#"
        id={id}
        className={className}
        style={style}
        title={title}
        onClick={handleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        {...extraDom}
      >
        {children}
      </a>
    )
  }

  return (
    <AniLink
      {...restProps}
      trigger={async pages => {
        const entry = await pages.entry
        const scrollingEl = id ? entry.node.querySelector(id) : null
        if (scrollingEl) {
          window.requestAnimationFrame(() => {
            scrollingEl.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            })
          })
        } else {
          window.requestAnimationFrame(() => {
            entry.node.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            })
          })
        }
      }}
    >
      {props.children}
    </AniLink>
  )
}

export default AnimationLink
